type Wall = { length: string; height: string; width?: string };
type SurfaceArea = 'surface' | 'area';
type Unit = 'm' | 'ft';

export type PaintCalculatorState = {
  walls: Wall[];
  unit: 'm' | 'ft';
  activeTab: 'surface' | 'area';
  showOpenings: boolean;
  doorsCount: number;
  windowsCount: number;
  estimatedArea: number;
  estimatedLitres: number;
};

export const initialState: PaintCalculatorState = {
  walls: [{ length: '', height: '' }],
  unit: 'm',
  activeTab: 'surface',
  showOpenings: false,
  doorsCount: 0,
  windowsCount: 0,
  estimatedArea: 0,
  estimatedLitres: 0,
};

export enum ActionType {
  RESET = 'RESET',
  SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
  SET_DOORS_COUNT = 'SET_DOORS_COUNT',
  SET_ESTIMATED_AREA = 'SET_ESTIMATED_AREA',
  SET_ESTIMATED_LITRES = 'SET_ESTIMATED_LITRES',
  SET_SHOW_OPENINGS = 'SET_SHOW_OPENINGS',
  SET_UNIT = 'SET_UNIT',
  SET_WALLS = 'SET_WALLS',
  SET_WINDOWS_COUNT = 'SET_WINDOWS_COUNT',
}

export type Action =
  | { type: ActionType.RESET }
  | {
      type: ActionType.SET_ACTIVE_TAB;
      payload: PaintCalculatorState['activeTab'];
    }
  | { type: ActionType.SET_DOORS_COUNT; payload: number }
  | { type: ActionType.SET_ESTIMATED_AREA; payload: number }
  | { type: ActionType.SET_ESTIMATED_LITRES; payload: number }
  | { type: ActionType.SET_SHOW_OPENINGS; payload: boolean }
  | { type: ActionType.SET_UNIT; payload: PaintCalculatorState['unit'] }
  | { type: ActionType.SET_WALLS; payload: PaintCalculatorState['walls'] }
  | { type: ActionType.SET_WINDOWS_COUNT; payload: number };

export const reducer = (
  state: PaintCalculatorState,
  action: Action,
): PaintCalculatorState => {
  switch (action.type) {
    case ActionType.RESET:
      return initialState;
    case ActionType.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };
    case ActionType.SET_DOORS_COUNT:
      return { ...state, doorsCount: action.payload };
    case ActionType.SET_ESTIMATED_AREA:
      return { ...state, estimatedArea: action.payload };
    case ActionType.SET_ESTIMATED_LITRES:
      return { ...state, estimatedLitres: action.payload };
    case ActionType.SET_SHOW_OPENINGS:
      return { ...state, showOpenings: action.payload };
    case ActionType.SET_UNIT:
      return { ...state, unit: action.payload };
    case ActionType.SET_WALLS:
      return { ...state, walls: action.payload };
    case ActionType.SET_WINDOWS_COUNT:
      return { ...state, windowsCount: action.payload };
    default:
      return state;
  }
};
